<div class="body-container-wrapper">
  <section class="retirement-home-page-banner p-0">
      <div class="container-fluid" style=" margin-bottom: 10px;">
          <div class="row align-items-start">
              <div class="col-md-8 col-sm-12">
                  <figure (click)="openTerm()">
                      <img src="../../../assets/images/Akshaya Tritya Landing Page_WEB.jpg" alt="" class="banner-img" (click)="desktopscroll()"  style="cursor: pointer;">
                  </figure>
              </div>
              <!-- Quiz Section -->
              <div class="col-md-4 col-sm-12">
                  <div class="card banner-form">
                      <div class="card-body" *ngIf="isQuizVisible">
                          <h3 class="form-title">Answer the below question to proceed further</h3>
                          <p style="margin-bottom: 10px;">{{quizQuestion}}</p>
                          <div *ngFor="let opt of quizOptions">
                              <label style="display: block; margin-bottom: 8px;">
                                  <input type="radio" name="quizAnswer" [value]="opt" [(ngModel)]="selectedQuizAnswer"> {{opt}}
                              </label>
                          </div>
                          <div class="errormsg" *ngIf="quizError">{{quizError}}</div>
                          <div class="text-center" style="margin-top: 15px;">
                              <button class="btn btn-primary" (click)="onQuizNext()">Next</button>
                          </div>
                      </div>
                      <!-- Form Section -->
                      <div class="card-body"  *ngIf="!isQuizVisible && isLeadFormVisible">
                          <h3 class="form-title">Fill the below details to proceed further</h3>
                          <p id="fill-form" style="color: red; display: none;">Fill in all the details to proceed further.</p>
                          <form #leadForm="ngForm" (ngSubmit)="PostData(leadForm)">
                              <div class="form-group">
                                  <label for="">Name<span class="asterisk"></span></label>
                                  <input type="text" autocomplete="off"
                                      id="name" name="name" [(ngModel)]="name" class="form-control"
                                      (blur)="removeErrorMsg('name')" placeholder="Please enter your full name"
                                      maxlength="40" 
                                      inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                                      (keydown)="alphaOnly($event)">
                                  <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                                      Invalid full name
                                  </div>
                                  <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                                      Full name is mandatory
                                  </div>
                              </div>
                              <div class="form-group">
                                  <label for="">Email Addresss </label>
                                  <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();" id="email" name="email"
                                      [(ngModel)]="email" class="form-control" placeholder="Your email id"
                                      maxlength="50" (blur)="removeErrorMsg('email')">
                                  <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                                      Invalid email id
                                  </div>
                                  <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
                                      Email id is mandatory
                                  </div>
                              </div>
                              <div class="form-group">
                                  <label for="">Mobile Number<span class="asterisk"></span></label>
                                  <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile"
                                      name="mobile" [(ngModel)]="mobile" class="form-control"
                                      placeholder="Enter Your mobile number" minlength="10" maxlength="10"
                                      pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')"
                                      inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                      (keypress)="numbersOnly($event)">
                                  <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                                      10 digit mobile number is mandatory
                                  </div>
                                  <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                                      Invalid mobile number
                                  </div>
                                  <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                                      Mobile number is mandatory
                                  </div>
                              </div>
                              <div class="form-group">
                                <label for="">City <span class="asterisk"></span></label>
                                <input type="text" autocomplete="off" id="city" name="city" [(ngModel)]="city" class="form-control"
                                      placeholder="Your city" maxlength="40"
                                      (keydown)="alphaOnly($event)" (blur)="removeErrorMsg('city')" 
                                      inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');">
                                  <div class="errormsg" *ngIf="cityValidateMsg == 'required'">
                                      City is mandatory
                                  </div>
                            </div>
                            <!-- Referral Section -->
                            <div class="form-group">
                              <div class="row g-2">
                                <!-- Referral 1 -->
                                <div class="col-12 col-sm-6">
                                  <label for="">Referral 1 Name<span class="asterisk"></span></label>
                                  <input type="text" autocomplete="off" id="referral1Name" name="referral1Name" [(ngModel)]="referral1Name" class="form-control"
                                    placeholder="Referral 1 Name" maxlength="40"
                                    (keydown)="alphaOnly($event)" (blur)="removeErrorMsg('referral1Name')"
                                    inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');">
                                  <div class="errormsg" *ngIf="referral1NameMsg">{{referral1NameMsg}}</div>
                                </div>
                                <div class="col-12 col-sm-6">
                                  <label for="">Referral 1 Mobile<span class="asterisk"></span></label>
                                  <input type="text" autocomplete="off" id="referral1Mobile" name="referral1Mobile" [(ngModel)]="referral1Mobile" class="form-control"
                                    placeholder="Referral 1 Mobile" minlength="10" maxlength="10"
                                    inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                    (keypress)="numbersOnly($event)" (blur)="removeErrorMsg('referral1Mobile')">
                                  <div class="errormsg" *ngIf="referral1MobileMsg">{{referral1MobileMsg}}</div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row g-2">
                                <!-- Referral 2 -->
                                <div class="col-12 col-sm-6">
                                  <label for="">Referral 2 Name<span class="asterisk"></span></label>
                                  <input type="text" autocomplete="off" id="referral2Name" name="referral2Name" [(ngModel)]="referral2Name" class="form-control"
                                    placeholder="Referral 2 Name" maxlength="40"
                                    (keydown)="alphaOnly($event)" (blur)="removeErrorMsg('referral2Name')"
                                    inputmode="text" oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');">
                                  <div class="errormsg" *ngIf="referral2NameMsg">{{referral2NameMsg}}</div>
                                </div>
                                <div class="col-12 col-sm-6">
                                  <label for="">Referral 2 Mobile<span class="asterisk"></span></label>
                                  <input type="text" autocomplete="off" id="referral2Mobile" name="referral2Mobile" [(ngModel)]="referral2Mobile" class="form-control"
                                    placeholder="Referral 2 Mobile" minlength="10" maxlength="10"
                                    inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                    (keypress)="numbersOnly($event)" (blur)="removeErrorMsg('referral2Mobile')">
                                  <div class="errormsg" *ngIf="referral2MobileMsg">{{referral2MobileMsg}}</div>
                                </div>
                              </div>
                            </div>
                            <div class="terms-conditions">
                              <small>
                                <a href="../../assets/Terms-and-Conditions.pdf" target="_blank" class="terms-link">
                                  *Terms and Conditions Apply
                                </a>
                              </small>
                            </div>
                            <div class="text-left position-relative pl-3">
                              <input
                                type="checkbox"
                                class="form-check-input checkbox2"
                                id="checkout1"
                                [(ngModel)]="checkedTerms"
                                name="check"
                              />
                              <small class="whatsappcontent">
                                  By continuing to use this Site/Page, you acknowledge and consent to receiving promotional or sales-related communications from BajajCapital Group. These communications may be sent via phone calls, SMS, WhatsApp, or email, using the contact details you have provided on the Site/Page.
                              </small>
                            </div>
                            <div class="text-center">
                                  <button type="submit" class="btn btn-primary" [disabled]="!checkedTerms"
                                      (click)="checkValidationMsg(leadForm)">Submit</button>
                              </div>
                          </form>
                      </div>
                      <!-- OTP and Thank You sections remain unchanged -->
                      <div class="card-body otp-card" *ngIf="isOtpFormVisible">
                          <div id="main_loader" style="display:none;">
                              <div class="loader-wrapper">
                                  <div class="lds-roller">
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                      <div></div>
                                  </div>
                              </div>
                          </div>
                          <h4 class="form-title">Maximize Your Tax Savings Now!</h4>
                          <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">
                              <p><a href="javascript:void(0)" id="btn-back" (click)="changeNumber()"><i
                                          class="fa fa-chevron-left"></i> Change Number</a></p>
                              <div class="alert alert-success">
                                  <i class="fa fa-check"></i>
                                  <span>OTP successfully sent on number {{displayMobile}}</span>
                              </div>
                              <div class="form-group">
                                  <input type="text" autocomplete="off"
                                      (keydown.space)="$event.preventDefault();" (keyup)="removeErrorMsg('otp')"
                                      id="otp" name="otp" [(ngModel)]="userOTP" class="form-control" maxlength="6"
                                      placeholder="Enter OTP" (keypress)="numberspincode($event)">
                                  <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                                      Invalid OTP
                                  </div>
                                  <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                                      Please enter OTP to continue.
                                  </div>
                                  <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP
                                  </div>
                              </div>
                              <div class="text-center">
                                  <button type="submit" class="btn btn-primary" id="otp_verify_btn"
                                      (click)="otpValidate()">Submit</button>
                              </div>
                              <div class="form-group text-center">
                                  <span *ngIf="isTimer">Didn't recieve OTP? Resend in <strong
                                          style="font-size:17px;">{{timeleft}} </strong>seconds</span>
                                  <a class="resendotp" href="javascript:void(0)" *ngIf="isResend"
                                      (click)="resendOTP()">Resend OTP</a>
                              </div>
                          </form>
                      </div>
                      <div class="card-body success-card" *ngIf="isThanksVisible">
                          <div class="success-tick">
                              <h2>Thank You For The Response!</h2>
                          </div>
                          <h6>Someone from our team will get back to you soon!</h6>
                      </div>
                  </div>
              </div>
              <!-- old form end  -->
          </div>
      </div>
  </section>
  <section class="second-section" id="mobilebanner" (click)="scroll()" style="display: none;cursor: pointer;">
      <img src="../../../assets/images/Akshaya Tritya Landing Page_Mobile.jpg" alt="mobile banner" width="1383" height="550" loading="eager" rel="preload" as="image" (click)="openTerm()">
  </section>
 
  
 

  <!-- New Image Sections -->
  <section class="landing-page-sections sub-banner-section">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center sub-banner-container">
          <h4 class="sub-banner-text">ACCOMPLISHING LIFE GOALS NEED A DEFINED PATH!<br>
              PRUDENT INVESTING INFUSES THE FUEL TO DRIVE THAT JOURNEY!</h4>
        </div>
      </div>
    </div>
  </section>

  <section class="landing-page-sections">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="section-heading">
              <h2>Significance of Life Goals</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    

  <section class="landing-page-sections">
      <div class="container">
        <div class="row justify-content-center text-center mb-4">
          <!-- Career Goals -->
          <div class="col-md-6 col-lg-3">
            <div class="goal-card text-start">
              <img src="../../../assets/images/Career Growth.png" alt="Career Goals" class="img-fluid mb-3">
              <h3 class="text-danger mb-3">CAREER GOALS</h3>
              <div style="text-align: left;padding: 0px 15px;font-size: 13px !important;">
                  <ul class="list-unstyled" >
                  <li class="goal-list">Help you perceive your career path</li>
                  <li class="goal-list">Enable you to understand the needs to achieve them</li>
                  <li class="goal-list">Give you the defined finances that will be needed</li>
                  </ul>
              </div>
            </div>
          </div>
          <!-- Married Life Goals -->
          <div class="col-md-6 col-lg-3">
            <div class="goal-card text-start">
              <img src="../../../assets/images/Couple at Airport.png" alt="Married Life Goals" class="img-fluid mb-3">
              <h3 class="text-danger mb-3">MARRIED LIFE GOALS</h3>
              <div style="text-align: left;padding: 0px 15px;">
                  <ul class="list-unstyled">
                  <li class="goal-list">Enables you to know the financial responsibilities</li>
                  <li class="goal-list">Lets you plan for today and tomorrow</li>
                  <li class="goal-list">Help you lay down a path to achieve goals of - Home, Car, Vacation, etc.</li>
                  </ul>
              </div>
            </div>
          </div>
          <!-- Family Goals -->
          <div class="col-md-6 col-lg-3">
            <div class="goal-card text-start">
              <img src="../../../assets/images/FAMILY GOALS.png" alt="Family Goals" class="img-fluid mb-3">
              <h3 class="text-danger mb-3">FAMILY GOALS</h3>
              <div style="text-align: left;padding: 0px 15px;">
                  <ul class="list-unstyled">
                      <li class="goal-list">Help you plan your family's future</li>
                      <li class="goal-list">Allow you to perceive a future for your children</li>
                      <li class="goal-list">Gives you the insight to plan for your Child's career path and requirements to achieve them</li>
                  </ul>
              </div>
            </div>
          </div>
          <!-- Retirement Goals -->
          <div class="col-md-6 col-lg-3">
            <div class="goal-card text-start">
              <img src="../../../assets/images/old couple cycling.png" alt="Retirement Goals" class="img-fluid mb-3">
              <h3 class="text-danger mb-3">RETIREMENT GOALS</h3>
              <div style="text-align: left;padding: 0px 15px;">
                  <ul class="list-unstyled">
                  <li >Make you think of the passions you want to explore</li>
                  <li>Help you understand the financial backing needed</li>
                  <li>Makes you realise the need for pre-defined planning to secure retirement</li>
                  </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    

  <section class="landing-page-sections desktop-section">
      <div class="container">
        <div class="row justify-content-center text-center mb-3">
          <div class="col-12">
            <h2 class="fw-bold text-uppercase">Strategic Planning to Achieve Life Goals</h2>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12">
            <img src="../../../assets/images/Sapno-Ki-Udaan-Landing-page_Final1.jpg" alt="Financial Goals Banner 3" class="img-fluid landing-banner">
          </div>
        </div>
      </div>
    </section>

    <section class="landing-page-sections mobile-section">
      <div class="container">
        <div class="row justify-content-center text-center mb-3">
          <div class="col-12">
            <h2 class="fw-bold text-uppercase">Strategic Planning to Achieve Life Goals</h2>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12">
            <img src="../../../assets/images/Sapno-Ki-Udaan-Landing-page_Final1_Mobile.jpg" alt="Financial Goals Banner 3" class="img-fluid landing-banner">
          </div>
        </div>
      </div>
    </section>
    

  <section class="landing-page-sections desktop-banner">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12" (click)="scroll()" style="cursor: pointer;">
          <img src="../../../assets/images/Sapno-Ki-Udaan-Landing-page_Banner-4.jpg" alt="Financial Goals Banner 4" class="img-fluid landing-banner">
        </div>
      </div>
    </div>
  </section>

  <section class="landing-page-sections mobile-banner">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12" (click)="scroll()" style="cursor: pointer;">
            <img src="../../../assets/images/Sapno-Ki-Udaan-Landing-page_Banner-4_mobile.jpg" alt="Financial Goals Banner 4" class="img-fluid landing-banner mobile-banner-img">
          </div>
        </div>
      </div>
    </section>

  <section class="landing-page-sections">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <div class="sapno-ki-udaan">
            <h2>GIVE THE RIGHT WINGS TO YOUR<br><span class="highlight">SAPNO KI UDAAN</span></h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="landing-page-sections">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <img src="../../../assets/images/Akshaya Tritya Landing Page_WEB_Footer.jpg" alt="Financial Goals Banner 6" class="img-fluid landing-banner" style="cursor: pointer;" (click)="openTerm()">
        </div>
      </div>
    </div>
  </section>


  <section class="landing-page-sections">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="financial-products">
              <p class="product-list">
                Retirement Planning<sup>$</sup> | Mutual Funds<sup>$</sup> | Life Insurance<sup>#</sup> | Health Insurance<sup>#</sup><br>
                Motor Insurance<sup>#</sup> | Bonds<sup>$</sup> | Company Fixed Deposits<sup>1</sup> | National Pension Scheme<sup>$</sup> | Real Estate<sup>2</sup>
              </p>
              <p class="tagline">
                We offers personalized financial strategies, ensuring you <strong>build, grow, and protect your wealth</strong><br>
                for every milestone and dream ahead.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    

  <div class="container">
      <p class="col-md-12 mt-3 terms"> <span style="font-weight: bold;">Disclaimer: </span>Bajaj Capital Limited (BCL) (CIN: U67120DL1965PLC004338) is a mutual fund distributor (ARN 0010) registered with AMFI. Registered Office: Mezzanine Floor, Bajaj House 97, Nehru Place, New Delhi-110019. Certain products and services offered by BCL may not be traded on the exchange. All disputes with respect to the distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund products only to its mutual fund distribution clients. For every other purpose, including distribution of non-mutual fund products, the circulated material is for informational purposes only. Further, it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for an investment decision. The views or expressions contained in the circulated material are not necessarily of BCL and BCL neither assumes any responsibility/liability nor does guarantee its accuracy, suitability, completeness and adequacy. The figures and data that may be appearing in the material are taken from various sources and BCL is not responsible for the accuracy of the same. The content of the material including images, charts, graphics and pictures are protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished, uploaded, posted, published, transmitted, displayed or distributed for any non-personal use without obtaining prior written permission, any non-adherence of which may attract appropriate legal action. Mutual Fund investments are subject to market risk, read all scheme-related documents carefully. The past performance of the scheme is not indicative of future performance. Investors are advised to seek appropriate advice from experts before taking any investment decisions. Nothing in the circulated material is intended to construe an advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial product.
    Stock Broking products offered through Bajaj Capital Markets Limited. #Product offered by Bajaj Capital Insurance Broking Limited. 1Product offered by Bajaj Capital Financial Services Limited. 2Product offered by Bajaj Capital Investment Centre Limited. $Services provided by Bajaj Capital Limited.</p>
  </div>
</div>